import type { CapacitorConfig } from '@capacitor/cli';

let config: CapacitorConfig;

let baseConfig: CapacitorConfig = {};

export const androidAppId = 'au.com.paytron.app';
export const iosAppId = 'com.paytron.app';

switch (process.env.ANDROID) {
    case 'android':
        baseConfig = {
            appName: 'Paytron',
            webDir: 'build',
            appId: androidAppId,
            bundledWebRuntime: false,
            backgroundColor: '0C1B43',
            plugins: {
                Splashscreen: {
                    launchAutoHide: true,
                    launchShowDuration: 0,
                },
                CapacitorHttp: {
                    enabled: false,
                },
            },
            cordova: {
                preferences: {
                    LottieBackgroundColor: '#FFFFFF',
                    LottieHideAfterAnimationEnd: 'true',
                    LottieFullScreen: 'true',
                    LottieFadeOutDuration: '700', // Android is in milliseconds
                    LottieAnimationLocation: 'public/img/animation.json',
                },
            },
            android: {
                webContentsDebuggingEnabled: false,
            },
        };
        break;
    default:
        baseConfig = {
            appName: 'Paytron',
            webDir: 'build',
            appId: iosAppId,
            bundledWebRuntime: false,
            plugins: {
                CapacitorHttp: {
                    enabled: false,
                },
            },
            cordova: {
                preferences: {
                    LottieBackgroundColor: '#FFFFFF',
                    LottieHideAfterAnimationEnd: 'true',
                    LottieFullScreen: 'true',
                    LottieFadeOutDuration: '0.7',
                    LottieAnimationLocation: 'public/img/animation.json',
                },
            },
            ios: {
                scheme: 'Paytron',
            },
        };

        break;
}

switch (process.env.NODE_ENV) {
    case 'prod':
        config = {
            ...baseConfig,
        };
        break;
    case 'staging':
        config = {
            ...baseConfig,
        };
        break;
    default:
        config = {
            ...baseConfig,
            server: {
                url: 'http://192.168.1.9:3000',
                cleartext: true,
            },
        };
        break;
}

const exportedConfig = config;

export default exportedConfig;
